// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"36e33f26","977":"c9c2c257"}[chunkId] + ".chunk.js";
};